import './constants.js';
import { RicosPluginToolbarNames } from 'ricos-types';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { InsertModal } from './modals/InsertModal.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { VERTICAL_EMBED_TYPE } from './types.js';
import 'ricos-schema';
import 'wix-rich-content-editor-common';
import './icons/Event.js';
import 'react';
import './icons/Booking.js';
import './icons/Product.js';
import 'ricos-context';
import './toolbar/VerticalEmbedInsertModal.js';
import '@wix/design-system';
import 'lodash';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './toolbar/ItemsList.js';
import 'wix-rich-content-common/libs/imageUtils';
import './convertDuration.js';
import 'ricos-content';
import 'ricos-schema/dist/statics/app_embed.defaults.json';
import 'wix-rich-content-plugin-commons';
import './tiptap/component.js';
import './viewer/vertical-embed-viewer.js';
import 'classnames';
import './CardContent-34835053.js';
import 'prop-types';
import 'wix-rich-content-common/libs/Tooltip';
import './components/Card.js';
import './viewer/verticalsDataBuilder.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginVerticalEmbed = (config) => {
  const pluginConfig = __spreadValues({}, config);
  return {
    config: pluginConfig,
    type: VERTICAL_EMBED_TYPE,
    tiptapExtensions,
    toolbar: {
      names: [RicosPluginToolbarNames.APP_EMBED],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getAddButtons: (config2, services) => getAddButtons(config2),
    __exports: {
      InsertModal
    }
  };
};

export { pluginVerticalEmbed };
//# sourceMappingURL=editor.js.map
